module.exports = __webpack_public_path__ + "app-static/img/icon-yhbsb.3f185c09.png";